"use client";
import { useState, ReactNode } from "react";

interface AccordionProps {
  title: string;
  children: ReactNode;
  isAccordion?: boolean;
  defaultOpen?: boolean;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
  chevronClassName?: string;
  chevronVariant?: "border" | "icomoon";
  ctProps?: string;
  dlProps?: string;
}

const BFLAccordion = ({
  title,
  children,
  isAccordion = false,
  defaultOpen = false,
  className = "",
  titleClassName = "",
  contentClassName = "",
  chevronClassName = "",
  chevronVariant = "border",
  ctProps,
  dlProps,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => {
    if (isAccordion) {
      const nextState = !isOpen;
      setIsOpen(nextState);
      if (dlProps || ctProps) {
        const parsedDl = dlProps ? JSON.parse(dlProps) : {};
        const parsedCt = ctProps ? JSON.parse(ctProps) : {};
        const updatedPayload = {
          ...parsedDl,
          sub_section: nextState ? "open" : "close",
        };
        const updatedCtPayload = {
          ...parsedCt,
          sub_section: nextState ? "open" : "close",
        };
        console.log("Accordion Click:", {
          dl: updatedPayload,
          ct: updatedCtPayload,
        });
      }
    }
  };
  // Determine content visibility classes
  const getContentClasses = () => {
    if (!isAccordion) return "max-h-[2000px] opacity-100";
    return isOpen ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0";
  };

  // Determine wrapper classes
  const getWrapperClasses = () => {
    const classes = "accordian-component w-full rounded-lg  md:py-2 mb-3";
    return classes;
  };

  const renderChevron = () => {
    if (chevronVariant === "icomoon") {
      return (
        <i
          className={`icomoon accord-arrow-icon inline-flex shrink-0 items-center justify-center text-[14px] leading-none text-gray-900 transition-transform duration-300 before:content-['\\e909'] ${
            isOpen ? "rotate-180" : ""
          } ${chevronClassName}`}
          aria-hidden="true"
        />
      );
    }

    return (
      <span
        className={`accord-arrow-icon mr-[5px] border-r-2 border-b-2 border-solid border-gray-900 p-[3px] text-sm transition-transform duration-300 md:mr-0 ${
          isOpen ? "rotate-[225deg]" : "rotate-45"
        } ${chevronClassName}`}
      />
    );
  };

  return (
    <div className={`${getWrapperClasses()} ${className}`}>
      {isAccordion ? (
        <div>
          <button
            className={`flex w-full cursor-pointer items-center justify-between rounded-t-lg text-left ${titleClassName}`}
            onClick={toggleAccordion}
            aria-expanded={isOpen}
            aria-controls="accordion-content"
            {...(ctProps && { "data-ct": ctProps })}
            {...(dlProps && { "data-dl": dlProps })}
          >
            <div className="flex items-center gap-2">
              <h2 className="mb-3 text-[18px] font-medium text-gray-900 md:!text-[20px]">
                {title}
              </h2>
            </div>

            {renderChevron()}
          </button>
        </div>
      ) : (
        <div className={`flex items-center justify-between rounded-t-lg ${titleClassName}`}>
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <h3 className="mb-3 text-[18px] font-medium text-gray-900 md:!text-[20px]">
                {title}
              </h3>
            </div>
          </div>
        </div>
      )}

      <div
        id="accordion-content"
        className={`overflow-hidden transition-all duration-300 ease-in-out ${getContentClasses()} ${contentClassName}`}
      >
        <div className="rounded-b-lg bg-white">{children}</div>
      </div>
    </div>
  );
};

export default BFLAccordion;
